<template>
    <Section v-if="product && hasRooms" class="checkout-hotel">
        <template #left>
            <HotelForm :product="product" :sectionId="sectionId" />
        </template>
        <template #right>
            <HotelDetails :product="product" />
        </template>
    </Section>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { defineComponent, computed } from 'vue';
    import { useStore } from '@/store';
    import { HotelProduct } from '@/api/Cart/cart.interfaces';
    import { isEmpty } from 'lodash';
    import Section from '../../../Shared/Section/Section.vue';
    import HotelForm from './Form/Form.vue';
    import HotelDetails from './Details/Details.vue';

    export default defineComponent({
        name: 'Hotel',
        methods: { t },
        props: {
            sectionId: { type: String, required: true },
            productId: { type: String, required: true },
        },
        components: { Section, HotelForm, HotelDetails },
        setup(props) {
            const store = useStore();

            const product = computed<HotelProduct | undefined>(() =>
                store.getters['cart/getProduct'](props.productId)
            );

            const hasRooms = computed(() => product.value && !isEmpty(product.value?.Rooms));

            return { product, hasRooms };
        },
    });
</script>

<style lang="scss">
    @forward 'Hotel.scss';
</style>
